class SchemaPreprocessor {
  static processRawSchema(rawSchema) {
    return {
      enums: this.processRawEnums(rawSchema.enums),
      entities: this.processRawEntities(rawSchema.entities)
    };
  }
  static processRawEnums(rawEnums) {
    const enums = /* @__PURE__ */ new Map();
    for (const { name, values } of rawEnums) {
      enums.set(name, new Set(values));
    }
    return enums;
  }
  static processRawEntities(rawEntities) {
    const entities = /* @__PURE__ */ new Map();
    for (const entity of rawEntities) {
      entities.set(entity.name, {
        customPrimaryAllowed: entity.customPrimaryAllowed,
        fields: this.processRawFields(entity.fields),
        name: entity.name,
        unique: entity.unique.map((it) => ({ fields: new Set(it.fields) }))
      });
    }
    return entities;
  }
  static processRawFields(rawFields) {
    const fields = /* @__PURE__ */ new Map();
    for (const field of rawFields) {
      fields.set(field.name, field);
    }
    return fields;
  }
}
export {
  SchemaPreprocessor
};
//# sourceMappingURL=SchemaPreprocessor.js.map
